import React__default from 'react';
import PropTypes from 'prop-types';
import { n as nodeOrStringProp } from './PropTypes-9aad034b.js';
import 'moment';

function Textarea(props) {
  var name = props.name,
    label = props.label,
    className = props.className,
    onChange = props.onChange,
    required = props.required,
    placeholder = props.placeholder,
    showError = props.showError,
    onKeyUp = props.onKeyUp,
    onKeyDown = props.onKeyDown,
    onKeyPress = props.onKeyPress,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    extraContent = props.extraContent,
    errorMessage = props.errorMessage,
    reference = props.reference,
    readOnly = props.readOnly,
    disabled = props.disabled,
    onClick = props.onClick,
    labelHint = props.labelHint,
    maxLength = props.maxLength,
    minLength = props.minLength;
  var textareaLabel = /*#__PURE__*/React__default.createElement("label", {
    htmlFor: name,
    className: "bf-form-element-label"
  }, label);
  var textareaWrapperClasses = "bf-form-element-wrapper\n        ".concat(required ? 'bf-form-element-is-required' : '', "\n        ").concat(showError ? 'bf-form-element-has-error' : '', "\n        ").concat(className, "\n    ");
  return /*#__PURE__*/React__default.createElement("div", {
    className: textareaWrapperClasses
  }, label ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-label-wrapper"
  }, labelHint ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, textareaLabel, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-label-hint"
  }, labelHint)) : textareaLabel) : null, /*#__PURE__*/React__default.createElement("div", {
    className: "bf-textarea-wrapper"
  }, /*#__PURE__*/React__default.createElement("textarea", {
    name: name,
    ref: reference,
    onChange: onChange,
    className: "bf-form-element ".concat(showError && 'bf-form-element-has-error'),
    onKeyUp: onKeyUp,
    onKeyDown: onKeyDown,
    onKeyPress: onKeyPress,
    onClick: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    required: required,
    readOnly: readOnly,
    disabled: disabled,
    maxLength: maxLength,
    minLength: minLength,
    placeholder: placeholder
  })), minLength || maxLength ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-textarea-length-reference"
  }, minLength && !maxLength ? /*#__PURE__*/React__default.createElement("span", null, "Min lenght", ': ', /*#__PURE__*/React__default.createElement("b", null, minLength)) : null, !minLength && maxLength ? /*#__PURE__*/React__default.createElement("span", null, "Max lenght", ': ', /*#__PURE__*/React__default.createElement("b", null, maxLength)) : null, minLength && maxLength ? /*#__PURE__*/React__default.createElement("span", null, "Lenght", ': ', /*#__PURE__*/React__default.createElement("b", null, minLength), ' / ', /*#__PURE__*/React__default.createElement("b", null, maxLength)) : null) : null, showError && errorMessage ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-error-message"
  }, errorMessage) : null, extraContent ? /*#__PURE__*/React__default.createElement("div", {
    className: "bf-form-element-extra-content"
  }, extraContent) : null);
}
Textarea.defaultProps = {
  className: '',
  label: '',
  labelHint: '',
  name: '',
  onBlur: function onBlur() {},
  onChange: function onChange() {},
  onFocus: function onFocus() {},
  onKeyDown: function onKeyDown() {},
  onKeyPress: function onKeyPress() {},
  onKeyUp: function onKeyUp() {},
  required: false,
  extraContent: '',
  readOnly: false,
  disabled: false,
  reference: null,
  onClick: function onClick() {},
  placeholder: '',
  maxLength: null,
  minLength: null,
  showError: false,
  errorMessage: ''
};
Textarea.propTypes = {
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Textarea label
   */
  label: nodeOrStringProp,
  /**
  Textarea hint
   */
  labelHint: nodeOrStringProp,
  /**
  Textarea name
   */
  name: PropTypes.string,
  /**
  Function onBlur
   */
  onBlur: PropTypes.func,
  /**
  Function onChange
   */
  onChange: PropTypes.func,
  /**
  Function onFocus
   */
  onFocus: PropTypes.func,
  /**
  Function onKeyDown
   */
  onKeyDown: PropTypes.func,
  /**
  Function onKeyPress
   */
  onKeyPress: PropTypes.func,
  /**
  Function onClick
   */
  onClick: PropTypes.func,
  /**
  Function onKeyUp
   */
  onKeyUp: PropTypes.func,
  /**
  Required Textarea
   */
  required: PropTypes.bool,
  /**
  Element render after Textarea
   */
  extraContent: nodeOrStringProp,
  /**
  readOnly Textarea
   */
  readOnly: PropTypes.bool,
  /**
  Textarea disabled
   */
  disabled: PropTypes.bool,
  /**
  Textarea ref
   */
  reference: PropTypes.shape({}),
  /**
  Textarea placeholder
   */
  placeholder: PropTypes.string,
  /**
  Textarea content maximum lenght
   */
  maxLength: PropTypes.number,
  /**
  Textarea content minimum lenght
   */
  minLength: PropTypes.number,
  /**
  Show Textarea with error status
   */
  showError: PropTypes.bool,
  /**
  Error message on error status
   */
  errorMessage: nodeOrStringProp
};

export default Textarea;
